module.exports = __webpack_public_path__ + "static/Newsletter16-905524fce96d150b09ba99044774b747.pdf";